import httpService from "..";

const emailQueueUrl = () =>
  `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/email-queue`;

export type EmailQueueStatus =
  | "QUEUED"
  | "SENT"
  | "FAILED"
  | "CANCELLED";

export type EmailQueueType = "PENDING_LAPSE_RUN" | "LAPSED_SUMMARY";

export interface EmailQueueItem {
  id: number;
  createdAt: string;
  updatedAt: string;
  status: EmailQueueStatus;
  emailType: EmailQueueType | string;
  toEmail: string;
  toName: string | null;
  subject: string;
  lapseRunId: number | null;
  meta: string | null;
  sentAt: string | null;
  errorMessage: string | null;
  flushedBy: string | null;
  /** Present on detail (by-id) responses when available */
  htmlBody?: string | null;
}

export interface GetEmailQueueParams {
  status?: EmailQueueStatus;
  emailType?: EmailQueueType | string;
  lapseRunId?: number | null;
}

export interface GetEmailQueueData {
  sendEnabled: boolean;
  items: EmailQueueItem[];
}

export interface CancelEmailQueuePayload {
  ids: number[];
}

export interface FlushEmailQueuePayload {
  ids?: number[];
  lapseRunId?: number | null;
}

export const getEmailQueueApi = async (params: GetEmailQueueParams = {}) => {
  return await httpService(emailQueueUrl(), "get", undefined, {
    status: params.status ?? "",
    emailType: params.emailType ?? "",
    lapseRunId: params.lapseRunId != null ? params.lapseRunId : "",
  });
};

export const getEmailQueueByIdApi = async (id: number | string) => {
  return await httpService(`${emailQueueUrl()}/${id}`, "get");
};

export const cancelEmailQueueApi = async (data: CancelEmailQueuePayload) => {
  return await httpService(`${emailQueueUrl()}/cancel`, "post", data);
};

export const flushEmailQueueApi = async (
  data: FlushEmailQueuePayload = {}
) => {
  return await httpService(`${emailQueueUrl()}/flush`, "post", data);
};
